import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import {LoginMenu} from "./api-authorization/LoginMenu";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import {Link, useNavigate} from "react-router-dom"; 
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CastConnectedIcon from "@mui/icons-material/CastConnected";
import BugReportIcon from "@mui/icons-material/BugReport";
import PersonIcon from "@mui/icons-material/Person";
import authService from '../components/api-authorization/AuthorizeService'
import Inventory2Icon from '@mui/icons-material/Inventory2';
import {createTheme, ThemeProvider} from "@mui/material/styles";
import AssessmentIcon from '@mui/icons-material/Assessment';
import HelpIcon from '@mui/icons-material/Help';
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import {InputAdornment, InputBase, TextField} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";


const buildRouteForSuggestion = (s) => {
    // expected shape: { type, id, label, meta }
    // meta can include projectId, entryId, etc
    switch (s.type) {
        case "channel":
            return `/channels/${s.id}`;
        case "brand":
            return `/brands/${s.id}`;
        case "project":
            return `/projects/${s.id}`;
        case "issue":
            return `/issues/${s.id}`;
        case "project_entry":
            // requires projectId + entryId
            return `/projects/${s.projectId}/entry/${s.entryId}`;
        case "video":
            // If you don't have a dedicated video route, send to the channel detail
            // (or create /videos/:id later)
            return s.channelId ? `/channels/${s.channelId}` : `/channels`;
        default:
            return "/";
    }
};


function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const navigate = useNavigate();

    const [searchOpen, setSearchOpen] = React.useState(false);
    const [searchText, setSearchText] = React.useState("");
    const [searchOptions, setSearchOptions] = React.useState([]);
    const [searchLoading, setSearchLoading] = React.useState(false);

    const lastFetchIdRef = React.useRef(0);
    const debounceRef = React.useRef(null);

    const fetchSuggestions = React.useCallback(async (q) => {
        const query = (q || "").trim();
        if (query.length < 2) {
            setSearchOptions([]);
            setSearchLoading(false);
            return;
        }

        const fetchId = ++lastFetchIdRef.current;
        setSearchLoading(true);

        try {
            const res = await fetch(`/api/search/suggest?q=${encodeURIComponent(query)}&limit=20`);
            authService.followIfLoginRedirect(res);

            if (!res.ok) throw new Error("Search failed");
            const data = await res.json();

            // protect against out-of-order responses
            if (fetchId !== lastFetchIdRef.current) return;

            setSearchOptions(Array.isArray(data) ? data : []);
        } catch (e) {
            if (fetchId !== lastFetchIdRef.current) return;
            console.error(e);
            setSearchOptions([]);
        } finally {
            if (fetchId === lastFetchIdRef.current) setSearchLoading(false);
        }
    }, []);

    const onSearchInputChange = (value) => {
        setSearchText(value);

        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            fetchSuggestions(value);
        }, 250);
    };
    
    return (

        <AppBar position="static" elevation={0}>
            <Container maxWidth="none" spacing={0} sx={{paddingLeft:"10px !important",paddingRight:"10px !important"}}>
               

                    <Stack   direction="row"
                             justifyContent="space-between"
                             alignItems="center"
                             spacing={0} sx={{mt:0.5}}>
                      
                        <Stack  direction={"row"} justifyContent="center"
                                 alignItems="center" sx={{minWidth:"150px"}}>
                            <Box  component="img" src={"/digitalslogov2_notag.png"}  sx={{  mt: 0, height:'30px' }} />
                            <Box sx={{display: {xs: 'block', md: 'none'}}}>
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleOpenNavMenu}
                                >
                                    <MenuIcon/>
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorElNav}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    open={Boolean(anchorElNav)}
                                    onClose={handleCloseNavMenu}
                                    sx={{
                                        display: {xs: 'block', md: 'none'},
                                    }}
                                >
                                    <MenuItem onClick={handleCloseNavMenu}>
                                        <Link component={"a"}  to="/" underline="none" sx={{mr:2, display:{md:'block'}}} >
                                            <Typography><DashboardIcon sx={{verticalAlign:"middle"}}/> Dashboard</Typography>
                                        </Link>
                                    </MenuItem>
                                    {authService.isInRole(["BASIC"]) && (
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Link component={"a"}  to="/projects" sx={{mr:5, display:{md:'block'}}}>
                                                <Typography><AccountTreeIcon  sx={{verticalAlign:"middle"}}/> Projects</Typography>
                                            </Link>
                                        </MenuItem>
                                    )}
                                    {authService.isInRole(["BASIC"]) && (
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Link tag={Button}  to="/issues">
                                                <Typography><BugReportIcon sx={{verticalAlign:"middle"}}/> Issues</Typography>
                                            </Link></MenuItem>)}
                                    {authService.isInRole(["BASIC"]) && (
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Link tag={Button}  to="/channels">
                                                <Typography><CastConnectedIcon sx={{verticalAlign:"middle"}}/> Channels</Typography>
                                            </Link></MenuItem>)}

                                   

                                    {authService.isInRole(["BASIC"]) && (
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Link tag={Button}  to="/brands">
                                                <Typography><Inventory2Icon sx={{verticalAlign:"middle"}}/> Brands</Typography>
                                            </Link></MenuItem>)}

                                    {authService.isInRole(["ADMIN"]) && (
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Link tag={Link}  to="/organisation">

                                                <Typography><PersonIcon sx={{verticalAlign:"middle"}}/> Organisation</Typography>
                                            </Link></MenuItem>)}

                                    <MenuItem onClick={handleCloseNavMenu}>
                                        <Link tag={Link}  to="/help">

                                            <Typography><HelpIcon sx={{verticalAlign:"middle"}}/> Help</Typography>
                                        </Link></MenuItem>
                                </Menu>
                            </Box>
                        </Stack>


                        <Grid container direction="row" justifyContent="center" alignItems="center">
                            <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                                justifyContent="center"
                                sx={{ width: "100%" }}
                            >
                                {/* Nav (desktop) */}
                                <Box sx={{ display: { xs: "none", md: "block" } }}>
                                    <Stack direction="row" spacing={2} className={"nav"} justifyContent="center" alignItems="center">
                                        <Link component={"a"} to="/" underline="none" sx={{ mr: 2, display: { md: "block" } }}>
                                            <Typography sx={{ fontSize: 15, fontWeight: 700 }}>
                                                <DashboardIcon sx={{ verticalAlign: "middle" }} /> Projects
                                            </Typography>
                                        </Link>

                                        {authService.isInRole(["BASIC"]) && (
                                            <Link tag={Button} to="/channels">
                                                <Typography sx={{ fontSize: 15, fontWeight: 700 }}>
                                                    <CastConnectedIcon sx={{ verticalAlign: "middle" }} /> Channels
                                                </Typography>
                                            </Link>
                                        )}

                                        {authService.isInRole(["BASIC"]) && (
                                            <Link tag={Button} to="/issues">
                                                <Typography sx={{ fontSize: 15, fontWeight: 700 }}>
                                                    <BugReportIcon sx={{ verticalAlign: "middle" }} /> Issues
                                                </Typography>
                                            </Link>
                                        )}

                                        {authService.isInRole(["BASIC"]) && (
                                            <Link tag={Button} to="/brands">
                                                <Typography sx={{ fontSize: 15, fontWeight: 700 }}>
                                                    <Inventory2Icon sx={{ verticalAlign: "middle" }} /> Brands
                                                </Typography>
                                            </Link>
                                        )}

                                        {authService.isInRole(["BASIC"]) && (
                                            <Link tag={Button} to="/reporting">
                                                <Typography sx={{ fontSize: 15, fontWeight: 700 }}>
                                                    <AssessmentIcon sx={{ verticalAlign: "middle" }} /> Reporting
                                                </Typography>
                                            </Link>
                                        )}
                                    </Stack>
                                </Box>

                                {/* Global Search (desktop + mobile) */}
                                <Box sx={{ flexGrow: 1, maxWidth: 250, display: { xs: "none", md: "block" } }}>
                                    <Autocomplete
                                        size="small"
                                        open={searchOpen}
                                        onOpen={() => setSearchOpen(true)}
                                        onClose={() => setSearchOpen(false)}
                                        options={searchOptions}
                                        loading={searchLoading}
                                        filterOptions={(x) => x}
                                        getOptionLabel={(opt) => opt?.label || ""}
                                        groupBy={(opt) => opt?.typeLabel || opt?.type || "Results"}
                                        isOptionEqualToValue={(a, b) => String(a?.key || a?.id) === String(b?.key || b?.id)}

                                        // ✅ NEW: control the input text
                                        inputValue={searchText}
                                        onInputChange={(_, value, reason) => {
                                            // reason can be: "input" | "reset" | "clear"
                                            // We only want to fetch when the user types.
                                            setSearchText(value);

                                            if (reason === "input") {
                                                if (debounceRef.current) clearTimeout(debounceRef.current);
                                                debounceRef.current = setTimeout(() => {
                                                    fetchSuggestions(value);
                                                }, 250);
                                            }

                                            if (reason === "clear") {
                                                setSearchOptions([]);
                                                setSearchLoading(false);
                                            }
                                        }}

                                        onChange={(_, val) => {
                                            if (!val) return;
                                            const to = buildRouteForSuggestion(val);
                                            setSearchOpen(false);
                                            setSearchText("");
                                            setSearchOptions([]);
                                            navigate(to);
                                        }}

                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                size="small"
                                                placeholder="Search channels, videos, brands, entries…"
                                                variant="outlined"
                                                sx={{
                                                    bgcolor: "background.paper",
                                                    borderRadius: 999,
                                                    "& .MuiOutlinedInput-root": { borderRadius: 999 },
                                                    "& input": { fontSize: 14 },
                                                }}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon fontSize="small" />
                                                        </InputAdornment>
                                                    ),
                                                    endAdornment: (
                                                        <React.Fragment>
                                                            {searchLoading ? <CircularProgress size={16} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    ),
                                                }}
                                            />
                                        )}

                                        renderOption={(props, option) => (
                                            <li {...props} key={option.key || `${option.type}-${option.id}`}>
                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                    <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                                        {option.label}
                                                    </Typography>
                                                    {option.subtitle ? (
                                                        <Typography variant="caption" color="text.secondary">
                                                            {option.subtitle}
                                                        </Typography>
                                                    ) : null}
                                                </Box>
                                            </li>
                                        )}
                                    />

                                </Box>
                            </Stack>
                        </Grid>


                        <Stack  sx={{minWidth:"150px"}}  direction={"row"} justifyContent="end"
                                alignItems="center">

                            <LoginMenu></LoginMenu>

                        </Stack>
                    </Stack>
            </Container>
        </AppBar>
    );
}

export default ResponsiveAppBar;
